import styles from "./index.module.scss";
import Carousel from "react-bootstrap/Carousel";
import React, { useState } from "react";

const Slider: React.FC = () => {
  // ACTIVE ELEMENT OF SLIDER
  const [index, setIndex] = useState(0);
  // ABBLE OR UNABLE DROB DOWN
  const [animate, setAnimate] = useState({
    left: styles.none,
    middle: styles.none,
    right: styles.none,
  });
  //  BLOCK OR UNBLOCK ON-CLIN EVENT
  const [block, setBlock] = useState(false);
  //  Style of each active element, middle element movement
  const [states, setStates] = useState({
    left: styles.active_left,
    middle: styles.disabled_middle,
    right: styles.disabled_right,
    middle_animation: "none",
  });

  const handleSelect = (selectedIndex: number) => {
    setIndex(selectedIndex);
    // Conditions
    let firstCondition = selectedIndex === 2 && index === 0;
    let secondCondition = selectedIndex === 0 && index === 2;
    let thirdCondition = selectedIndex === 1;
    let fourthCondition = selectedIndex === 2;

    setStates({
      ...states,
      left:
        firstCondition || thirdCondition || fourthCondition
          ? styles.disabled_left
          : styles.active_left,
      middle:
        firstCondition || fourthCondition
          ? styles.disabled_middle1
          : thirdCondition
          ? styles.active_middle
          : styles.disabled_middle,
      right:
        firstCondition || fourthCondition
          ? styles.active_right
          : styles.disabled_right,
      middle_animation:
        firstCondition || secondCondition ? styles.animate_middle : " none",
    });
    setTimeout(() => {
      // Unblocking event
      setBlock(false);
    }, 1000);
  };

  return (
    <>
      <div className="container">
        <Carousel
          className={styles.slider}
          activeIndex={index}
          onSelect={handleSelect}
          indicators={false}
          controls={false}
          pause={"hover"}
          slide={false}
          interval={5000}
        >
          <Carousel.Item
            className={styles.item + " " + states.left + " " + animate.left}
            onClick={() => {
              if (index != 0 && !block) {
                // Go down animation
                setAnimate({ ...animate, left: styles.godown });
                // Blocking
                setBlock(true);
                setTimeout(() => {
                  // Activating picked element
                  handleSelect(0);
                  // Go down off
                  setAnimate({ ...animate, left: styles.none });
                }, 1000);
              }
            }}
          >
            <div className={styles.content}>
              <h3>Автозапчасти вовремя</h3>
              <p>47 млн Автозапчастей по всей России</p>
            </div>
            <div className={styles.loading}>
              <div></div>
            </div>
          </Carousel.Item>
          <Carousel.Item
            className={
              styles.item +
              " " +
              states.middle +
              " " +
              states.middle_animation +
              " " +
              animate.middle
            }
            onClick={() => {
              if (index != 1 && !block) {
                setAnimate({ ...animate, middle: styles.godown });
                setBlock(true);
                setTimeout(() => {
                  handleSelect(1);
                  setAnimate({ ...animate, middle: styles.none });
                }, 1000);
              }
            }}
          >
            <div className={styles.content}>
              <h3>Магазины в СНГ и в России</h3>
              <p>
                50 000 магазинов по всей стране и 20 000 пунктов выдачи по всему
                миру{" "}
              </p>
            </div>
            <div className={styles.loading}>
              <div></div>
            </div>
          </Carousel.Item>
          <Carousel.Item
            className={styles.item + " " + states.right + " " + animate.right}
            onClick={() => {
              if (index != 2 && !block) {
                setAnimate({ ...animate, right: styles.godown });
                setBlock(true);
                setTimeout(() => {
                  handleSelect(2);
                  setAnimate({ ...animate, right: styles.none });
                }, 1000);
              }
            }}
          >
            <div className={styles.content}>
              <h3>Гарантия Качества </h3>
              <p>
                Используем систему автоконтроля качества и проверяем подлинность
                товаров в экспертной лаборатории «Контрафакта.нет». Доставляем
                99,3% запчастей без ошибок. Если товар не подходит или вы
                передумали его покупать — сделаем бесплатный возврат.
              </p>
            </div>
            <div className={styles.loading}>
              <div></div>
            </div>
          </Carousel.Item>
        </Carousel>
      </div>
    </>
  );
};

export default Slider;
